import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

export function useResponsivenessScoreEnabled(): boolean {
	const {
		data: { responsivenessData },
	} = useDecisionMakerProfilePageData();

	return responsivenessData.isVisible;
}
